import type { FC } from "react";
import { Button, Spinner } from "flowbite-react";
import { HiTrash } from "react-icons/hi";

interface DeleteButtonProps {
  onDelete: () => void;
  isDeleting: boolean;
  disabled?: boolean;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
  showText?: boolean;
}

const DeleteButton: FC<DeleteButtonProps> = ({
  onDelete,
  isDeleting,
  disabled = false,
  size = "sm",
  className = "h-8",
  showText = true,
}) => {
  return (
    <Button
      size={size}
      color="failure"
      onClick={onDelete}
      disabled={disabled || isDeleting}
      className={className}
    >
      <div className="flex items-center gap-1">
        {isDeleting ? (
          <Spinner size="sm" className="fill-white text-white" />
        ) : (
          <HiTrash className="w-4 h-4" />
        )}
        {showText && "Delete"}
      </div>
    </Button>
  );
};

export default DeleteButton;
